module.exports = __webpack_public_path__ + "img/d1c0757.png";